import React from "react"
import { Modal, Row, Col, Button } from "antd"
import "./styles.scss"
import PropTypes from "prop-types"

const BaseModal = ({
  type,
  title,
  subtitle,
  okButtonText,
  okButtonColor,
  cancelButtonText,
  children,
  onCancel,
  onClose,
  onOk,
  isVisible,
  hasButtons,
  width,
  isLoading,
  isClosable,
  className,
  featureImgSrc,
}) => {

  return (
    <Modal
      className={`base-modal base-modal-${type} ${className}`}
      width={width}
      visible={isVisible}
      onCancel={onClose ?? onCancel}
      closable={isClosable}
      title={
        <>
          <p className="title">{title}</p>
        </>
      }
      footer={
        hasButtons ? (
          <Row
            gutter={[24, 24]}
            justify="space-between"
            className="actions-base-modal"
          >
            {onCancel && (
              <Col
                align="center"
                className={"left-btn"}
                xs={24}
                sm={24}
                md={onOk ? 12 : 24}
                lg={onOk ? 12 : 24}
              >
                <Button disabled={isLoading} onClick={onCancel}>
                  {cancelButtonText ?? "Cancelar"}
                </Button>
              </Col>
            )}
            {onOk ? (
              <Col
                align="center"
                className={`right-btn ${okButtonColor ?? ""}`}
                xs={24}
                sm={24}
                md={onCancel ? 12 : 24}
                lg={onCancel ? 12 : 24}
              >
                <Button isLoading={isLoading} onClick={onOk} type="primary">
                  {okButtonText ?? "OK"}
                </Button>
              </Col>
            ) : null}
          </Row>
        ) : null
      }
    >
      <p className="subtitle-modal">{subtitle}</p>
      <div className="content-modal">{children}</div>
    </Modal>
  )
}

BaseModal.defaultProps = {
  hasButtons: true,
  with: 520,
  closable: true,
  className: "",
  type: "general",
}

BaseModal.propTypes = {
  type: PropTypes.oneOf(["alert", "error", "success", "general"]).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  okButtonText: PropTypes.string,
  okButtonColor: PropTypes.oneOf(["blue", "red"]),
  cancelButtonText: PropTypes.string,
  children: PropTypes.any,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  onOk: PropTypes.func,
  isVisible: PropTypes.bool,
  hasButtons: PropTypes.bool,
  width: PropTypes.number,
  isLoading: PropTypes.bool,
  isClosable: PropTypes.bool,
  className: PropTypes.string,
  featureImgSrc: PropTypes.node,
}

export default BaseModal
